//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "Statistical",
  components: {},
  props: [],
  data: function data() {
    return {
      value: "",
      routerList: [{
        name: "大厅统计",
        path: "/statistical/all"
      }, {
        name: "部门统计",
        path: "/statistical/department"
      }, {
        name: "学院统计",
        path: "/statistical/college"
      }, {
        name: "个人统计",
        path: "/statistical/user"
      }]
    };
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {},
  destroyed: function destroyed() {},
  methods: {},
  watch: {},
  filters: {}
};